export const UPDATED_ADVANCED_APPOINTMENT_STEP_DATA =
  "UPDATED_ADVANCED_APPOINTMENT_STEP_DATA";
export const UPDATED_END_DATE_DATE_PICKER_VISIBILITY =
  "UPDATED_END_DATE_DATE_PICKER_VISIBILITY";
export const UPDATED_ON_DATE_DATE_PICKER_VISIBILITY =
  "UPDATED_ON_DATE_DATE_PICKER_VISIBILITY";
export const GOT_BOOKINGS_FOR_RESOURCE_WITHIN_DATES_FOR_CLASH_SECTION =
  "GOT_BOOKINGS_FOR_RESOURCE_WITHIN_DATES_FOR_CLASH_SECTION";
export const GET_BOOKINGS_FOR_RESOURCE_WITHIN_DATES_FOR_CLASH_SECTION =
  "GET_BOOKINGS_FOR_RESOURCE_WITHIN_DATES_FOR_CLASH_SECTION";
export const GET_BOOKINGS_FOR_RESOURCE_WITHIN_DATES_FOR_SPECIFIC_RECURRING_SECTION =
  "GET_BOOKINGS_FOR_RESOURCE_WITHIN_DATES_FOR_SPECIFIC_RECURRING_SECTION";
export const GOT_BOOKINGS_FOR_RESOURCE_WITHIN_DATES_FOR_SPECIFIC_RECURRING_SECTION =
  "GOT_BOOKINGS_FOR_RESOURCE_WITHIN_DATES_FOR_SPECIFIC_RECURRING_SECTION";

export function updateAdvancedAppointmentStepData(stepData) {
  return {
    type: UPDATED_ADVANCED_APPOINTMENT_STEP_DATA,
    data: stepData
  };
}

export function updateEndDateDatePickerVisibility(open) {
  return {
    type: UPDATED_END_DATE_DATE_PICKER_VISIBILITY,
    data: open
  };
}

export function updateRecurringOnDateDatePickerAppointment(open) {
  return {
    type: UPDATED_ON_DATE_DATE_PICKER_VISIBILITY,
    data: open
  };
}

export const getBookingsForResourceWithinDatesForClashSection = (
  resourceId,
  startDate,
  endDate,
  bookingId,
  newlySelectedDate,
  indexOfClash
) => {
  return {
    type: GET_BOOKINGS_FOR_RESOURCE_WITHIN_DATES_FOR_CLASH_SECTION,
    data: {
      resourceId,
      startDate,
      endDate,
      bookingId,
      newlySelectedDate,
      indexOfClash
    }
  };
};
export const getBookingsForResourceWithinDatesForSpecificRecurringSection = (
  resourceId,
  startDate,
  endDate,
  newlySelectedDate
) => {
  return {
    type: GET_BOOKINGS_FOR_RESOURCE_WITHIN_DATES_FOR_SPECIFIC_RECURRING_SECTION,
    data: {
      resourceId,
      startDate,
      endDate,
      newlySelectedDate
    }
  };
};
